// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2r5sz","gfeWrapper":"CalendarEvent_gfeWrapper__1ef_Z"};